
import { User, Ruler, Weight, Globe, Heart, MapPin } from "lucide-react";
import LocationPrecisionDisplay from "@/components/location/LocationPrecisionDisplay";

interface GprofileInfoProps {
  profile: {
    position: string | null;
    body_type: string | null;
    height: number | null;
    weight: number | null;
    ethnicity: string | null;
    relationship_status: string | null;
    location: string | null;
    location_precision_meters?: number | null;
    show_location_precision?: boolean | null;
  };
  isOwnProfile?: boolean;
}

const GprofileInfo = ({ profile, isOwnProfile = false }: GprofileInfoProps) => {
  const infoFields = [
    {
      icon: User,
      label: "Role",
      value: profile.position,
    },
    {
      icon: User,
      label: "Body Type",
      value: profile.body_type,
    },
    {
      icon: Ruler,
      label: "Height",
      value: profile.height ? `${Math.floor(profile.height / 12)}'${profile.height % 12}"` : null,
    },
    {
      icon: Weight,
      label: "Weight",
      value: profile.weight ? `${profile.weight} lbs` : null,
    },
    {
      icon: Globe,
      label: "Ethnicity",
      value: profile.ethnicity,
    },
    {
      icon: Heart,
      label: "Relationship",
      value: profile.relationship_status,
    },
    {
      icon: MapPin,
      label: "Location",
      value: profile.location,
    },
  ];

  const visibleFields = infoFields.filter(field => field.value);
  const hasLocationPrecision = profile.location_precision_meters && 
    (isOwnProfile || profile.show_location_precision);

  if (visibleFields.length === 0 && !hasLocationPrecision) return null;

  return (
    <div className="px-4 py-6 border-b border-ice-white/10">
      <h2 className="text-lg font-semibold text-toxic-green mb-4">Profile Info</h2>
      <div className="grid grid-cols-1 gap-3">
        {visibleFields.map((field, index) => (
          <div key={index} className="flex items-center gap-3 p-3 bg-ice-white/5 rounded-lg">
            <field.icon className="w-5 h-5 text-toxic-green flex-shrink-0" />
            <div className="flex-1">
              <span className="text-ice-white/60 text-sm">{field.label}</span>
              <p className="text-ice-white font-medium">{field.value}</p>
            </div>
          </div>
        ))}
        
        {/* Location Precision Display */}
        {hasLocationPrecision && (
          <LocationPrecisionDisplay
            precisionMeters={profile.location_precision_meters || 300}
            showToOthers={profile.show_location_precision || false}
            isOwnProfile={isOwnProfile}
          />
        )}
      </div>
    </div>
  );
};

export default GprofileInfo;
